import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "./PestManagementDiseases.css";
import Footer from "../Home/Footer";
import PestManagmentImage from "../assets/img/Pestmanagement.jpg";
import DiseaseManagmentImage from "../assets/img/DiseasePrevention.jpg";
import PestManagementSlider1 from "../assets/img/PestManagementSlider-1.jpg";
import PestManagementSlider2 from "../assets/img/PestManagementSlider-2.jpg";
import PestManagementSlider3 from "../assets/img/PestManagementSlider-3.jpg";

const carouselItems = [
  {
    image: PestManagementSlider1,
    title: "Effective Pest Control",
    description: "Protect your crops with advanced pest management solutions.",
  },
  {
    image: PestManagementSlider2,
    title: "Disease Prevention",
    description:
      "Keep your crops healthy with preventive measures and treatments.",
  },
];

const infoSections = [
  {
    title: "🐛 Pest Management",
    description:
      "Effective pest control is crucial for maintaining crop health and ensuring a high yield. Our solutions include biological control, organic pesticides, and integrated pest management strategies.",
    list: [
      "Use of eco-friendly pesticides",
      "Crop rotation to prevent infestations",
      "Introducing natural predators",
    ],
    image: PestManagmentImage,
    reverse: false,
  },
  {
    title: "🌾 Disease Prevention",
    description:
      "Crop diseases can cause significant damage if not managed properly. Our solutions help farmers prevent, identify, and control plant diseases effectively.",
    list: [
      "Early disease detection techniques",
      "Use of resistant crop varieties",
      "Proper soil and water management",
    ],
    image: DiseaseManagmentImage,
    reverse: true,
  },
];

const PestManagementDiseases = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    // <div className="pest-page">
    //   {/* 🔹 Hero Section (Carousel) */}
    //   <section className="carousel-section" data-aos="fade-down">
    //     <Swiper
    //       modules={[Pagination, Navigation, Autoplay]}
    //       pagination={{ clickable: true }}
    //       navigation={true}
    //       autoplay={{ delay: 3000, disableOnInteraction: false }}
    //       loop={true}
    //       className="custom-swiper"
    //     >
    //       {carouselItems.map((item, index) => (
    //         <SwiperSlide key={index}>
    //           <div
    //             className="carousel-item"
    //             style={{ backgroundImage: `url(${item.image})` }}
    //             data-aos="zoom-in"
    //           >
    //             <div className="overlay">
    //               <h2 style={{ color: "#d4561a" }} data-aos="fade-up">
    //                 {item.title}
    //               </h2>
    //               <p data-aos="fade-up" data-aos-delay="200">
    //                 {item.description}
    //               </p>
    //             </div>
    //           </div>
    //         </SwiperSlide>
    //       ))}
    //     </Swiper>
    //   </section>

    //   {/* 🔹 Information Sections */}
    //   {infoSections.map((section, index) => (
    //     <section
    //       className={`info-section ${section.reverse ? "alt-bg" : ""}`}
    //       data-aos="fade-up"
    //       key={index}
    //     >
    //       <div className="container">
    //         <div
    //           className={`pest-row align-items-center ${
    //             section.reverse ? "flex-md-row-reverse" : ""
    //           }`}
    //           data-aos="fade-right"
    //         >
    //           <div className="col-md-6">
    //             <h2 style={{ color: "#d4561a" }} data-aos="fade-up">
    //               {section.title}
    //             </h2>
    //             <p data-aos="fade-up" data-aos-delay="100">
    //               {section.description}
    //             </p>
    //             <ul data-aos="fade-up" data-aos-delay="200">
    //               {section.list.map((item, idx) => (
    //                 <li key={idx}>{item}</li>
    //               ))}
    //             </ul>
    //           </div>
    //           <div className="col-md-6 text-center">
    //             <img
    //               src={section.image}
    //               alt={section.title}
    //               className="img-fluid"
    //               data-aos="zoom-in"
    //             />
    //           </div>
    //         </div>
    //       </div>
    //     </section>
    //   ))}

    //   {/* 🔹 Contact Section */}
    //   {/* <section className="contact-section" data-aos="fade-up">
    //     <div className="container text-center">
    //       <h2 style={{ color: "#d4561a" }} data-aos="fade-up">
    //         📞 Get in Touch
    //       </h2>
    //       <p data-aos="fade-up" data-aos-delay="100">
    //         Need help with pest or disease management? Contact us today!
    //       </p>
    //       <Link
    //         to="/contact-us"
    //         className="btn btn-primary"
    //         data-aos="fade-up"
    //         data-aos-delay="200"
    //       >
    //         Contact Us
    //       </Link>
    //     </div>
    //   </section> */}

    //   <Footer />
    // </div>
    <section id="recent-posts" className="recent-posts section">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div
              className="p-5 rounded shadow"
              style={{ backgroundColor: "#fff8e1" }}
            >
              <h2
                className="mb-3"
                style={{ fontSize: "2rem", color: "#ff6f00" }}
              >
                🚧 Coming Soon
              </h2>
              <p style={{ fontSize: "1.1rem", color: "#555" }}>
                This section is under construction. Stay tuned for our latest
                posts and updates!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PestManagementDiseases;
